module.exports = __webpack_public_path__ + "static/media/referralWebBanner.543152c5.png";